<template>
  <div class="tictactoe">
    <iframe
      height="350"
      style="width: 100%;"
      scrolling="no"
      title="TicTacToe"
      src="https://codepen.io/sam_saama/embed/VwvzdKX?height=265&theme-id=light&default-tab=result"
      frameborder="no"
      allowtransparency="true"
      allowfullscreen="true"
      loading="lazy"
    >
      See the Pen
      <a href="https://codepen.io/sam_saama/pen/VwvzdKX">TicTacToe</a> by Sam S
      (<a href="https://codepen.io/sam_saama">@sam_saama</a>) on
      <a href="https://codepen.io">CodePen</a>.
    </iframe>
  </div>
</template>

<script>
  export default {
    name: 'Tic-tac-toe'
  }
</script>
